(() => {
    let Search      = App.Interface.Search;
    let pathname    = App.Variable('url');

    /* Mode (subscription | b2b) */
    Search.setMode(App.Variable('mode') || 'overview');
    /**
     * As types we want to present in this page.
     * The order represents the position in the collection
     */
    Search.Type.reset();
    Search.Type
        .add('product')
    ;

    Search.Filter.import(
        decodeURI(window.location.href.replace(pathname, '')
            .replace(/\?.*/,'')
        )
    );

    Search.Observer.register({
        update: () => {
            if (typeof (history.pushState) != 'undefined') {
                if (window.location.href.indexOf(pathname) !== -1) {
                    let uri = Search.Filter.export() ?
                        [pathname, Search.Filter.export()].join('/') : pathname ;
                    const obj = { Page: '', Url: uri};
                    history.replaceState(obj, obj.Page, obj.Url);
                }
            }
            /* Handle windows title */
            let subtitle = [];
            let title = document.title.split('|');
            subtitle.push(title[0].trim());
            for (let key in App.Interface.Search.filters) {
                if (!App.Interface.Search.filters[key].selected) continue;
                subtitle.push(App.Interface.Search.filters[key].label);
            }
            document.title = subtitle.join(' | ');
        }
    });
    // Expose Overview for external handling
    App.Components.wait('.component.overview', 'Instance', Overview => window.Overview = Overview);
})();
